// A parallel set of definitions need to be maintained in @ratehub/base-ui for the time being.
// In the unlikely event of any changes, remember to keep in sync.
const LOCALES = {
    ENGLISH: 'en-CA',
    FRENCH: 'fr-CA',
    PSEUDO: 'en-xa',
};

export default LOCALES;
